<template>
  <div class="card">
    <div class="card-body">
      <b-table head-row-variant="info" table-variant="white"
               :items="currentVisitList"
               :fields="currentVisitListHeaders"
               hover
               responsive
               sort-icon-left
               show-empty>
        <template #empty="scope">
          <h6 class="text-center my-5">
            {{scope.loading ? "Lütfen Bekleyin" : noCurrentVisitMessage ? noCurrentVisitMessage : "Veri Bulunamadı" }}
          </h6>
        </template>
        <template #table-busy>
          <div class="text-center">
            <b-spinner variant="primary" size="lg" label="Lütfen Bekleyin...">
            </b-spinner>
          </div>
        </template>
        <template #cell(visitDate)="data">
          <div class="text-center">
            <span>{{formattedDate(data.item.visitDate)}}</span>
          </div>
        </template>
        <template #cell(process)="data">
          <div class="text-center">
            <v-tooltip top>
              <template v-slot:activator="{on, attrs}">
                <v-btn v-bind="attrs" v-on="on" icon color="amber darken-2" @click="openNewVisitDialog(data.item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Düzenle</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{on, attrs}">
                <v-btn v-bind="attrs" v-on="on" icon color="amber darken-2" @click="_currentVisitDelete(data.item.id)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
              <span>Sil</span>
            </v-tooltip>
          </div>
        </template>
      </b-table>
      <NewCurrentVisitDialog
          :visitProp="editCurrentVisitProp"
          :processType="'edit'"
          :showDialog="editCurrentVisitDialog"
          @dialogChange="(data) => (editCurrentVisitDialog = data)">
      </NewCurrentVisitDialog>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import NewCurrentVisitDialog from "@/components/current-visit/dialogs/NewVisitDialog.vue";

import {numberConverter} from "../../../../helpers";
import {formattedDate} from "@/momentHelper";

export default {
  components: {
    NewCurrentVisitDialog,
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("cart", ["current"]),
    ...mapState("visit", [
      "currentVisitList",
      "currentVisitListHeaders",
      "currentVisitListLoading",
      "currentVisitListMetaData",
      "noCurrentVisitMessage",
        "selectedCurrentCode"
    ]),
  },
  data() {
    return {
      showNewVisitDialog: false,
      editCurrentVisitProp: null,
      editCurrentVisitDialog: false,
    };
  },
  methods: {
    numberConverter,
    formattedDate,
    ...mapActions("visit", ["currentVisitDelete","fetchCurrentVisitList"]),
    ...mapActions("cart", ["fetchSingleCartList"]),
    openNewVisitDialog(data) {
      this.editCurrentVisitProp = data
      this.editCurrentVisitDialog = true;
    },
    async _currentVisitDelete(id) {
      await this.currentVisitDelete({
        params: {},
        body: {},
        urlSegments: [id],
      })
    },
  },
  watch: {
    "editCurrentVisitProp": function (newVal) {
      if (!newVal) {
        this.editCurrentVisitProp = null;
      }
    }
  }
};
</script>